// generated from 624 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastPurchaseByAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_purchase_by_app_filter"),
  comparison_key: z.enum([
    "4", // 567 (90.87%)
    "6", // 44 (7.05%)
    "3", // 9 (1.44%)
    "5", // 4 (0.64%)
  ]),
  display_name: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 32 (5.13%), defined 592 (94.87%)
  raw_value: z
    .union([
      // number samples: 582 (98.31%)
      // integer: 573 (98.45%)
      // avg: 11.46, min: 0.041666666666666664, max: 168
      z.number().nonnegative(),
      // string samples: 10 (1.69%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 611 (97.92%)
    // integer: 594 (97.22%)
    // avg: 11.02, min: 0, max: 168
    z.number().min(0),
    // string samples: 13 (2.08%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
